import { render, staticRenderFns } from "./Bon.vue?vue&type=template&id=5d2ce570&scoped=true"
import script from "./Bon.vue?vue&type=script&lang=js"
export * from "./Bon.vue?vue&type=script&lang=js"
import style0 from "./Bon.vue?vue&type=style&index=0&id=5d2ce570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2ce570",
  null
  
)

export default component.exports